import { render } from "./FilteredCollection.vue?vue&type=template&id=7ea4ba38&scoped=true"
import script from "./FilteredCollection.vue?vue&type=script&lang=js"
export * from "./FilteredCollection.vue?vue&type=script&lang=js"

import "./FilteredCollection.vue?vue&type=style&index=0&id=7ea4ba38&scoped=true&lang=css"
import "./FilteredCollection.vue?vue&type=style&index=1&id=7ea4ba38&scoped=true&lang=css"
import "./FilteredCollection.vue?vue&type=style&index=2&id=7ea4ba38&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea4ba38"]])

export default __exports__